import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const initialState = {
    token: "",
    director: false
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { director } = jwtDecode(action.payload.accessToken);
            state.token = action.payload.accessToken;
            state.director = director;
        },
        clearCredentials: (state, action) => {
            state.token = "";
            state.director = false;
        }
    }
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export default authSlice.reducer;

export const select_authenticated = state => state.auth.token;

export const select_director = state => state.auth.director;